
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'LogOut',
  props: ['onLogOut'],
})
